import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Sentry - Debe inicializarse ANTES de React
import { initSentry } from "./lib/sentry";
initSentry();

// Error Boundary
import { AppErrorBoundary } from "./components/error/AppErrorBoundary";

// Providers globales
import { AppProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthProvider";
import { ToasterProvider } from "./components/ui/Toaster";

import "./index.css";

// PWA: registro recomendado por vite-plugin-pwa (con prompt de actualización)
import { initPwaUpdate } from "./lib/pwaUpdate";

// El boot actual cargó bien: liberamos la bandera de auto-reload por chunk roto
// (ver AppErrorBoundary) para que un futuro deploy pueda volver a dispararla.
sessionStorage.removeItem("chunk-error-reload");

// ❌ Nada de App Check acá. Lo inicializamos en firebase.ts

if (import.meta.env.PROD) {
  initPwaUpdate();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AppProvider>
        <AuthProvider>
          <ToasterProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToasterProvider>
        </AuthProvider>
      </AppProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
